import { useEffect, useRef } from 'react';

function usePrevious<T>(value: T, delayMs = 0): T | undefined {
  const ref = useRef<T>();
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (delayMs > 0) {
      timeoutRef.current = setTimeout(() => {
        ref.current = value;
      }, delayMs);
    } else {
      ref.current = value;
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, delayMs]);

  return ref.current;
}

export default usePrevious;
